import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useDeleteValidator(id) {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.super_admins.coaches.enable_delete_data(id))
      .then((response) => {
        setData(response.data.data);
      });
  }, []);

  return data;
}
